/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Container } from "./BannerStyles";
import { EXECUTION_INTERVAL, MAX_TIMEOUT_COUNT, config } from './config'
import { useAdSlot } from "../../../hooks/useAdSlot";
import { CreativeEventType } from "./creative/creative-event";
import { setHasBanner } from '../../../store/banner/actions';
import { AppState } from "../../../store";
import { trackBanner } from "../../../monitoring/x-ray-tracker";

type BannerContainer = HTMLDivElement | null | undefined;
type Iframe = HTMLIFrameElement | null | undefined;

const Banner: React.FC = () => {

  let intervalId: NodeJS.Timer;
  let timeoutCount = 0;
  const dispatch = useDispatch();

  const permissions = useSelector((state: AppState) => state.permissions)
  const hasBanner = useSelector((state: AppState) => state.banner.hasBanner)

  useAdSlot({
    id: config.id,
    sizes: config.sizes,
    path: config.campainId,
    chainId: `${permissions.current_drugstore?.chain.id || ''}`,
    target: config.target
  })

  const setWidthAndHeightOfBanner = (): void => {
    if (timeoutCount === MAX_TIMEOUT_COUNT) {
      clearInterval(intervalId);
      timeoutCount = 0;
      return;
    }

    timeoutCount += 1;

    const container = document.querySelector('#banner-dispenser') as BannerContainer;
    const iframe = container?.querySelector('iframe') as Iframe;


    if (!container || !iframe) {
      clearInterval(intervalId);
      intervalId = setInterval(setWidthAndHeightOfBanner, EXECUTION_INTERVAL);
      return;
    }

    dispatch(setHasBanner(!!iframe))

    iframe.width = `${container.offsetWidth}px`;

    const carousel = iframe.contentWindow?.document.querySelector('.carousel') as HTMLDivElement;

    if (!carousel) {
      clearInterval(intervalId);
      intervalId = setInterval(setWidthAndHeightOfBanner, EXECUTION_INTERVAL);
      return;
    }

    carousel.style.width = `${container.offsetWidth}px`;
    
    clearInterval(intervalId);
  };

  const onCreativeEvent = (event: MessageEvent<CreativeEventType>): void => {
    const from = 'admanager';
    const to = 'dispenser';
    const isAllowed = from === event.data.from && to === event.data.to;

    if (!isAllowed) return;
    const { data: { eventName, bannerContent } } = event.data;
    if (!eventName && !bannerContent?.id) return;

    const {
      current_drugstore
    } = permissions

    trackBanner(eventName, {
      drugstore_id: current_drugstore?.id,
      drugstore_name: permissions.user.name,
      drugstore_uf: current_drugstore?.uf || '',
      chain_id: current_drugstore?.chain.id,
      chain_name: current_drugstore?.chain.name,
      banner_campaign_name: bannerContent.creative,
      banner_content: bannerContent
    })
    
  };

  useEffect(() => {
    window.addEventListener('message', onCreativeEvent);
    setWidthAndHeightOfBanner()
    return () => {
      window.removeEventListener('message', onCreativeEvent);
      clearInterval(intervalId)
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setWidthAndHeightOfBanner]);



  return <Container id={config.id} hasBanner={hasBanner} />
};

export default Banner